
import React from 'react';
import { Newspaper } from 'lucide-react';
import FooterLinksColumn from './FooterLinksColumn';
import NewsSection from './NewsSection';

const FooterLinks = () => {
  const offeringsLinks = [
    {
      text: 'Hire yourself',
      url: '/subscription-model',
      isExternal: false
    },
    {
      text: 'Managed hiring (Assisted model)',
      url: '/assisted-sourcing-models',
      isExternal: false
    },
    {
      text: 'Startup Support Plan',
      url: '/startup-offering',
      isExternal: false
    },
    {
      text: 'AI Screener',
      url: 'https://cutshort.io/ai-screener',
      isExternal: true
    }
  ];

  const tryOutLinks = [
    {
      text: 'Try candidate searches',
      url: 'https://cutshort.io/hire-for-role',
      isExternal: true
    },
    {
      text: 'Salary calculator for tech roles',
      url: 'https://cutshort.io/check-salary-in-india',
      isExternal: true
    }
  ];

  const resourcesLinks = [
    {
      text: 'The Talent Tales Newsletter',
      url: 'https://newsletter.cutshort.io/',
      isExternal: true
    },
    {
      text: 'Ebooks',
      url: 'https://cutshort.io/resources/ebooks',
      isExternal: true
    },
    {
      text: 'Responsible AI',
      url: '/responsible-ai',
      isExternal: false
    }
  ];

  const communitiesLinks = [
    {
      text: 'Gen-AI Recruiters community',
      url: 'https://cutshort.io/a/genai-recruiters-nas',
      isExternal: true
    },
    {
      text: 'TA Refresh community',
      url: 'https://cutshort.io/a/ta-refresh-web',
      isExternal: true
    }
  ];

  const aboutLinks = [
    {
      text: 'Our Team',
      url: 'https://cutshort.io/about',
      isExternal: true
    },
    {
      text: 'Security',
      url: 'https://cutshort.io/security',
      isExternal: true
    },
    {
      text: 'Terms',
      url: 'https://cutshort.io/terms',
      isExternal: true
    },
    {
      text: 'Privacy policy',
      url: 'https://cutshort.io/privacy',
      isExternal: true
    },
    {
      text: 'For support, email support@cutshort.io',
      url: 'mailto:support@cutshort.io',
      isExternal: true
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-8 mb-12">
      <FooterLinksColumn 
        title="Our Offerings" 
        links={offeringsLinks} 
      />
      
      <FooterLinksColumn 
        title="Try Out" 
        links={tryOutLinks} 
      />
      
      <FooterLinksColumn 
        title="Resources" 
        links={resourcesLinks} 
      />
      
      <FooterLinksColumn 
        title="Communities/Meetups" 
        links={communitiesLinks} 
      />
      
      <FooterLinksColumn 
        title="About Cutshort" 
        links={aboutLinks} 
      />
      
      <NewsSection />
    </div>
  );
};

export default FooterLinks;
